import React, { Component } from "react";
import { connect } from "react-redux";
import { replace } from "connected-react-router";
import classNames from "classnames";

import { actions as recoveryPasswordActions, selectors as recoveryPasswordSelectors } from "reducers/recoveryPassword";
import { actions as loginActions } from "reducers/login";
import { actions as softTokenActions, selectors as softTokenSelectors } from "reducers/softToken";

import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import Step1Content from "pages/recoveryPassword/_components/Step1Content";
import LogoTitle from "pages/login/_components/LogoTitle";
import Head from "pages/_components/Head";

class RecoveryPassStep1 extends Component {
    componentDidMount() {
        this.props.dispatch(recoveryPasswordActions.recoveryPassCleanUp());
        this.props.dispatch(softTokenActions.getTokenInfo());
    }

    onHeaderClose = () => {
        this.props.dispatch(loginActions.reset());
    };

    onHeaderBack = () => {
        const { dispatch } = this.props;
        dispatch(replace("/loginStep2"));
    };

    render() {
        const mainContainerClass = classNames({
            "main-container": true,
            "container-fluid": this.props.isDesktop,
        });
        const { isDesktop } = this.props;
        return (
            <React.Fragment>
                <Head
                    title=""
                    styleOther={{ backgroundColor: "transparent", boxShadow: "none" }}
                    onBack={this.onHeaderBack}
                    hideNavbarInMobile
                />
                <Notification scopeToShow="recoveryPassword" />
                {!isDesktop && <LogoTitle />}
                <MainContainer className={mainContainerClass}>
                    <Step1Content {...this.props} />
                </MainContainer>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    showCaptcha: recoveryPasswordSelectors.getShowCaptcha(state),
    tokenInfo: softTokenSelectors.getTokenInfo(state),
    deviceStatus: softTokenSelectors.getDeviceStatus(state),
});

export default connect(mapStateToProps)(RecoveryPassStep1);
